var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-autocomplete',{staticClass:"search-address-bar",on:{"place_changed":_vm.placeChanged}}),_c('gmap-map',{staticStyle:{"width":"100%","height":"500px","max-width":"100%"},attrs:{"center":_vm.pos,"zoom":7,"map-type-id":"terrain"},on:{"click":_vm.setNewLocation}},[(_vm.marker != null)?_c('gmap-marker',{key:_vm.marker.lat,attrs:{"position":_vm.marker,"icon":{
        url: 'icons/silo-marker.png',
        scaledSize: { height: 40, width: 40 },
      }}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }